module.exports = __webpack_public_path__ + "img/icon-md-mood-03.31275602.svg";